import { render, staticRenderFns } from "./SiteMovedDialog.vue?vue&type=template&id=12fc6d8a&"
import script from "./SiteMovedDialog.vue?vue&type=script&lang=js&"
export * from "./SiteMovedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports